import React, { useRef } from "react";
import { ContentCarouselControl, IconButtonControl } from "doshx_controls_web";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import { CarouselShimmer } from "../shimmer/shimmer_types";
import { Shimmer } from "../shimmer/shimmer";
import { NoContentMessage } from "../no_content_message";
import { ProductGridViewItem } from "../product-grid-view/components/product-grid-view-item";
export function ProductsCarousel({ title, items, isLoading }) {
    const carouselRef = useRef(null);
    return isLoading ? (React.createElement("div", { className: "pt-8" },
        React.createElement("div", { className: "py-5" },
            React.createElement(Shimmer, { width: "40%", height: "2em" })),
        React.createElement(CarouselShimmer, null))) : items && items.length > 0 ? (React.createElement("div", { className: "pt-8" },
        React.createElement("div", { className: "flex flex-row justify-between items-start gap-3 pb-6" },
            title,
            React.createElement("div", { className: "flex gap-2" },
                React.createElement(IconButtonControl, { icon: faArrowLeft, onClick: () => {
                        carouselRef.current?.prev();
                    }, backgroundColor: "bg-light-gray", backgroundHoverColor: "hover:bg-light-gray/80", iconColor: "text-primary", shape: "circle", size: "small", borderColor: "border-transparent" }),
                React.createElement(IconButtonControl, { icon: faArrowRight, onClick: () => {
                        carouselRef.current?.next();
                    }, backgroundColor: "bg-primary", backgroundHoverColor: "hover:bg-primary/80", iconColor: "text-light-gray", shape: "circle", size: "small", borderColor: "border-transparent" }))),
        React.createElement(ContentCarouselControl, { ref: carouselRef, infinite: true, borderRadius: "rounded-none", heightClasses: "h-[520px]", viewport: 2, shortSwipes: true, addPadding: false, spaceBetween: 20, addShadow: false, showPills: false, autoPlay: false, centerSlides: false, items: items.map((product) => {
                return {
                    content: React.createElement(ProductGridViewItem, { key: product._id, product: product }),
                };
            }), breakpoints: {
                sm: {
                    viewport: 2,
                },
                md: {
                    viewport: 2.4,
                },
                lg: {
                    viewport: 3.4,
                },
                xl: {
                    viewport: 4.4,
                },
                xxl: {
                    viewport: 4.4,
                },
            } }))) : (React.createElement(NoContentMessage, { messages: ["No products found."] }));
}
